import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { Helmet } from "react-helmet-async";
import getFileExtension from "../../../utils/helpers/get-file-extension";
import PreDeliveryInspectionLeadFormParent from "../pre-delivery-inspection-lead-form-parent";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Heading } from "@cars24/turbo-web/lib/heading";
import CarTruthLogo from "./images/car-truth-logo.svg";

const PreDeliveryInspectionBanner = ({
    details
}) => {
    const { title: heroImageTitle = "", subTitle: heroImageSubTitle = "", sectionData = {} } = details || {};

    const { url = "" } = sectionData?.desktopImage || {};

    const { tokens } = useTokens();

    return (
        <React.Fragment styleName={"styles.preDeliveryInspectionBanner"}>
            <Helmet>
                <link
                    rel="preload"
                    href={url}
                    imageSrcSet={url}
                    as={"image"}
                    type={`image/${getFileExtension(url)}`}
                    fetchpriority="high"
                />
            </Helmet>
            <div styleName={"styles.bannerWrapper"}>
                <div styleName={"styles.imageWrapperBox"}>
                    <img
                        fetchpriority="high"
                        src={url}
                        alt="Pdi Banner"
                    />
                </div>
                <div styleName={"styles.bannerTextWrapper"}>
                    <div styleName={"styles.pdiBannerText"}>
                        <img src={CarTruthLogo} alt="car-truth-logo" />
                        {heroImageTitle && <Heading level={1} color={tokens.text_default_text_inverse}>{heroImageTitle}</Heading>}
                        {heroImageSubTitle && <Heading level={2} color={tokens.text_default_text_inverse}>{heroImageSubTitle}</Heading>}
                    </div>
                    <PreDeliveryInspectionLeadFormParent details={details}/>
                </div>
            </div>
        </React.Fragment>
    );
};

PreDeliveryInspectionBanner.propTypes = {
    details: PropTypes.object,
    isSsr: PropTypes.bool
};

export default PreDeliveryInspectionBanner;
